import { validateEmail } from '../../utils/validate'
import { client } from '../../client'

const validate = async (values: {
  phoneNumber: number
  email: string
  status: any
  online: boolean
  onsite: boolean
  language: string
}) => {
  const errors: Partial<Record<keyof typeof values, string>> = {}

  if (!values.language) {
    errors.language = 'Vereist'
  }

  if (!values.phoneNumber) {
    errors.phoneNumber = 'Voer ten minste een telefoonnummer in.'
  }
  if (values.email && !validateEmail(values.email)) {
    errors.email = 'Het opgegeven e-mailadres is ongeldig.'
  }
  if (!values.status) {
    errors.status = 'Geef een status op.'
  }

  if (!values.online && !values.onsite) {
    errors.online = 'Moet online of ter plaatse zijn'
    errors.onsite = 'Moet online of ter plaatse zijn'
  }

  //if any of the fields are missing, simply return here
  if (
    Object.keys(errors) &&
    Object.keys(errors)?.length &&
    Object.keys(errors)?.length > 0
  ) {
    return errors
  }

  //validate uniqueness for all users
  if (values.email && validateEmail(values.email)) {
    const data = await client.findPatientByEmailOrPhoneNumber({
      email: values.email
    })
    const patientId = data?.data?.patient?.id
    if (patientId) {
      errors.email =
        'Het opgegeven emailadres is al bekend. Mail naar info@ om toegang te krijgen tot het dossier.' // t('emailTaken')
    }
  }
  if (values.phoneNumber) {
    const data = await client.findPatientByEmailOrPhoneNumber({
      phoneNumber: values.phoneNumber
    })
    const patientId = data?.data?.patient?.id
    if (patientId) {
      errors.phoneNumber =
        'Het opgegeven telefoonnummer is al bekend. Mail naar info@ om toegang te krijgen tot het dossier.' //t('phoneNumberTaken')
    }
  }
  return errors
}

export default validate
